import './TransformacionSection.scss';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import logo_educacion from '../../../assets/images/logo_educacion.png';
import classroom from '../../../assets/images/classroom.png';
import directivos from '../../../assets/images/img_directivos.webp';
import manifiestodi from '../../../assets/documents/Pieza1_C3_INF01_02 PDF.pdf';
import manifiestodo from '../../../assets/documents/manifiesto_docentes_ap.pdf';
import manifiestoDocentes2025 from '../../../assets/documents/2025/Pieza2_C5F_INF01_01 PDF_Ver2.pdf';
import manifiestoDocentes2024 from '../../../assets/documents/Pieza2_C5F_INF01_01 PDF.pdf';
import manifiestoNacional from '../../../assets/documents/2025/manifiestos/manifiesto-nacional/MEN_MANIFIESTO_NACIONAL.pdf';
// Documentos técnicos 2025
import docPIAR from '../../../assets/documents/2025/documentos-tecnicos/PDF/MEN_UNAL_C4_PIAR.pdf';
import docTDAH from '../../../assets/documents/2025/documentos-tecnicos/PDF/MEN_UNAL_C4_ORIENTACIONES TDAH.pdf';
import docTalentos from '../../../assets/documents/2025/documentos-tecnicos/PDF/MEN_UNAL_C4_ORIENTACIONES TALENTOS.pdf';
import docInforme from '../../../assets/documents/2025/documentos-tecnicos/PDF/MEN_UNAL_C4_INFORME ACCIONES ESTRATEGICAS.pdf';
import docDiscapacidad from '../../../assets/documents/2025/documentos-tecnicos/PDF/MEN_UNAL_C4_ORIENTACIONES DISCAPACIDAD.pdf';
import docMEN_DOC01 from '../../../assets/documents/2025/documentos-tecnicos/DOC01/MEN_DOC01.pdf';
import revistaApartado from '../../../assets/documents/2025/revistas/apartado/MEN_REV_APARTADO.pdf';
// Manifiestos regionales 2025
import manifiestoAntioquia from '../../../assets/documents/2025/manifiestos/01_ANTIOQUIA/MEN_MANIFIESTO_APARTADÓ.pdf';
import manifiestoAntioquiaImg from '../../../assets/documents/2025/manifiestos/01_ANTIOQUIA/MEN_MANIFIESTO_APARTADÓ.jpg';
import manifiestoMitu from '../../../assets/documents/2025/manifiestos/02_MITU/MEN_MANIFIESTO_MITU.pdf';
import manifiestoMituImg from '../../../assets/documents/2025/manifiestos/02_MITU/MEN_MANIFIESTO_MITU.jpg';
import manifiestoChoco from '../../../assets/documents/2025/manifiestos/03_CHOCO/MEN_MANIFIESTO_QUIBDO.pdf';
import manifiestoChocoImg from '../../../assets/documents/2025/manifiestos/03_CHOCO/MEN_MANIFIESTO_QUIBDO.jpg';
import manifiestoGuainia from '../../../assets/documents/2025/manifiestos/04_GUAINIA/MEN_MANIFIESTO_PTO_INIRIDA.pdf';
import manifiestoGuainiaImg from '../../../assets/documents/2025/manifiestos/04_GUAINIA/MEN_MANIFIESTO_PTO-INIRIDA.jpg';
import manifiestoHuila from '../../../assets/documents/2025/manifiestos/05_HUILA/MEN_MANIFIESTO_PITALITO.pdf';
import manifiestoHuilaImg from '../../../assets/documents/2025/manifiestos/05_HUILA/MEN_MANIFIESTO_PITALITO.jpg';
import manifiestoNteSantander from '../../../assets/documents/2025/manifiestos/06_NTE-DE-SANTANDER/MEN_MANIFIESTO_CUCUTA.pdf';
import manifiestoNteSantanderImg from '../../../assets/documents/2025/manifiestos/06_NTE-DE-SANTANDER/MEN_MANIFIESTO_CUCUTA.jpg';
import manifiestoGuajira from '../../../assets/documents/2025/manifiestos/07_LA-GUAJIRA/MEN_MANIFIESTO_GUAJIRA.pdf';
import manifiestoGuajiraImg from '../../../assets/documents/2025/manifiestos/07_LA-GUAJIRA/MEN_MANIFIESTO_GUAJIRA.jpg';
import manifiestoCordoba from '../../../assets/documents/2025/manifiestos/08_CORDOBA/MEN_MANIFIESTO_MONTERIA.pdf';
import manifiestoCordobaImg from '../../../assets/documents/2025/manifiestos/08_CORDOBA/MEN_MANIFIESTO_MONTERIA.jpg';
import manifiestoMeta from '../../../assets/documents/2025/manifiestos/09_META/MEN_MANIFIESTO_VILLAVICENCIO.pdf';
import manifiestoMetaImg from '../../../assets/documents/2025/manifiestos/09_META/MEN_MANIFIESTO_VILLAVICENCIO.jpg';
import manifiestoCauca from '../../../assets/documents/2025/manifiestos/10_CAUCA/MEN_MANIFIESTO_CAUCA.pdf';
import manifiestoCaucaImg from '../../../assets/documents/2025/manifiestos/10_CAUCA/MEN_MANIFIESTO_CAUCA.jpg';
import manifiestoCasanare from '../../../assets/documents/2025/manifiestos/11_CASANARE/MEN_MANIFIESTO_CASANARE.pdf';
import manifiestoCasanareImg from '../../../assets/documents/2025/manifiestos/11_CASANARE/MEN_MANIFIESTO_CASANARE.jpg';
import manifiestoCaqueta from '../../../assets/documents/2025/manifiestos/12_CAQUETA/MEN_MANIFIESTO_FLORENCIA.pdf';
import manifiestoCaquetaImg from '../../../assets/documents/2025/manifiestos/12_CAQUETA/MEN_MANIFIESTO_FLORENCIA.jpg';
import manifiestoPutumayo from '../../../assets/documents/2025/manifiestos/13_PUTUMAYO/MEN_MANIFIESTO_PUTUMAYO.pdf';
import manifiestoPutumayoImg from '../../../assets/documents/2025/manifiestos/13_PUTUMAYO/MEN_MANIFIESTO_PUTUMAYO.jpg';
import manifiestoGuaviare from '../../../assets/documents/2025/manifiestos/14_GUAVIARE/MEN_MANIFIESTO_GUAVIARE.pdf';
import manifiestoGuaviareImg from '../../../assets/documents/2025/manifiestos/14_GUAVIARE/MEN_MANIFIESTO_GUAVIARE.jpg';
import manifiestoTolima from '../../../assets/documents/2025/manifiestos/15_TOLIMA/MEN_MANIFIESTO_TOLIMA.pdf';
import manifiestoTolimaImg from '../../../assets/documents/2025/manifiestos/15_TOLIMA/MEN_MANIFIESTO_TOLIMA.jpg';
import manifiestoVichada from '../../../assets/documents/2025/manifiestos/16_VICHADA/MEN_MANIFIESTO_VICHADA.pdf';
import manifiestoVichadaImg from '../../../assets/documents/2025/manifiestos/16_VICHADA/MEN_MANIFIESTO_VICHADA.jpg';
import manifiestoValle from '../../../assets/documents/2025/manifiestos/17_VALLE/MEN_MANIFIESTO_VALLE.pdf';
import manifiestoValleImg from '../../../assets/documents/2025/manifiestos/17_VALLE/MEN_MANIFIESTO_VALLE.jpg';
import manifiestoSantander from '../../../assets/documents/2025/manifiestos/18_SANTANDER/MEN_MANIFIESTO_SANTANDER.pdf';
import manifiestoSantanderImg from '../../../assets/documents/2025/manifiestos/18_SANTANDER/MEN_MANIFIESTO_SANTANDER.jpg';
import manifiestoSucre from '../../../assets/documents/2025/manifiestos/19_SUCRE/MEN_MANIFIESTO_SUCRE.pdf';
import manifiestoSucreImg from '../../../assets/documents/2025/manifiestos/19_SUCRE/MEN_MANIFIESTO_SUCRE.jpg';
import testimony1 from '../../../assets/images/testimony_1.webp';
import testimony3 from '../../../assets/images/testimony_3.webp';
import testimony4 from '../../../assets/images/testimony_4.webp';
import testimony5 from '../../../assets/images/testimony_5.webp';
import testimony6 from '../../../assets/images/testimony_6.webp';
import ico_download from '../../../assets/images/ico_download.svg';
import { Dialog, DialogContent, Button, Tabs, Tab, Box } from '@mui/material';
import { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';
import { Link } from 'react-router-dom';
// Videos experiencias 2025
import video2025_01 from '../../../assets/media/2025/01_ANTIOQUIA_F.mp4';
import video2025_02 from '../../../assets/media/2025/02_VAUPES_F.mp4';
import video2025_03 from '../../../assets/media/2025/03_CHOCO_F.mp4';
import video2025_04 from '../../../assets/media/2025/04_GUAINIA_F.mp4';
import video2025_05 from '../../../assets/media/2025/05_HUILA_F.mp4';
import video2025_06 from '../../../assets/media/2025/06_CAQUETA_F.mp4';
import video2025_07 from '../../../assets/media/2025/07_CORDOBA_F.mp4';
import video2025_08 from '../../../assets/media/2025/08_N SANTANDER_F.mp4';
import video2025_09 from '../../../assets/media/2025/09_GUAJIRA_F.mp4';
import video2025_10 from '../../../assets/media/2025/10_META_F.mp4';
import video2025_11 from '../../../assets/media/2025/11_CAUCA_F.mp4';
import video2025_12 from '../../../assets/media/2025/12_CASANARE_F.mp4';
import video2025_13 from '../../../assets/media/2025/13_PUTUMAYO_F.mp4';
import video2025_14 from '../../../assets/media/2025/14_GUAVIARE_F.mp4';
import video2025_15 from '../../../assets/media/2025/15_VICHADA_F.mp4';
import video2025_16 from '../../../assets/media/2025/16_TOLIMA_F.mp4';
import video2025_17 from '../../../assets/media/2025/17_SANTANDER_F.mp4';
import video2025_18 from '../../../assets/media/2025/18_VALLE_F.mp4';
import video2025_19 from '../../../assets/media/2025/19_SUCRE_F.mp4';

const CardDirectivos = ({ title, text, fullText, video }: any) => {

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
      <>  
          <Grid container className='card-directivos-container' onClick={() => handleOpen()} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleOpen(); } }} aria-label={`Ver video: ${title}`}>
            <Grid container item xs={12} className='title-container'>
              <Typography className='title'>
                {title}
              </Typography>
            </Grid>
            <Grid container item xs={12} className='img-item'>
              <iframe src={video} className='info-img' title={`Video: ${title}`} />
            </Grid>
            <Grid container item xs={12} className='text-container'>
              <Typography className='text'>
                {text}
              </Typography>
            </Grid>
          </Grid>
          <Dialog open={open} onClose={handleClose} maxWidth='lg' className='modal-directivos'>
            <DialogContent style={{ padding: 20 }}>
              <Grid container item xs={12} className='text-container'>
                <Typography className='title'>
                  {title}
                </Typography>
              </Grid>
              <Grid container item xs={12} className='video-container'>
                <iframe src={video} className='video-item' allowFullScreen title={`Video: ${title}`} />
              </Grid>
              <Grid container item xs={12} className='text-container'>
                <Typography className='text-info'>
                  {fullText}
                </Typography>
              </Grid>
            </DialogContent>
        </Dialog>
      </>
  );
}

const CardVideo2025 = ({ title, text, video }: any) => {

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
      <>  
          <Grid container className='card-video2025-container' onClick={() => handleOpen()} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleOpen(); } }} aria-label={`Ver video: ${title}`}>
            <Grid container item xs={12} className='title-container'>
              <Typography className='title'>
                {title}
              </Typography>
            </Grid>
            <Grid container item xs={12} className='video-preview'>
              <video className='video-thumbnail' muted>
                <source src={video} type="video/mp4" />
              </video>
              <div className='play-overlay'>
                <div className='play-button'>▶</div>
              </div>
            </Grid>
            <Grid container item xs={12} className='text-container'>
              <Typography className='text'>
                {text}
              </Typography>
            </Grid>
          </Grid>
          <Dialog open={open} onClose={handleClose} maxWidth='lg' className='modal-video2025'>
            <DialogContent style={{ padding: 20 }}>
              <Grid container item xs={12} className='text-container'>
                <Typography className='title'>
                  {title}
                </Typography>
              </Grid>
              <Grid container item xs={12} className='video-container'>
                <video controls className='video-player' autoPlay>
                  <source src={video} type="video/mp4" />
                  Tu navegador no soporta el formato de video.
                </video>
              </Grid>
              <Grid container item xs={12} className='text-container'>
                <Typography className='text-info'>
                  {text}
                </Typography>
              </Grid>
            </DialogContent>
        </Dialog>
      </>
  );
}

const CardDocentes = ({ title, img, imgDesc, autor, testimonio }: any) => {

  return (
      <>  
          <Grid container className='card-docentes-container'>
            <Grid container item xs={12} className='img-item'>
              <img src={img} alt={imgDesc} className='info-img' />
            </Grid>
            <Grid container item xs={12} className='title-container'>
              <Typography className='title'>
                {title}
              </Typography>
            </Grid>
            <Grid container item xs={12} className='text-container'>
              <Typography className='text'>
                {autor}
              </Typography>
            </Grid>
            <div className='button-container'>
              <Link to={`/transformacion-desde-el-aula/testimonios/${testimonio}?query=transformacion`} aria-label={`Ver testimonio completo: ${title}`}>
                <Button variant="contained" fullWidth className='testimony-button'>
                    <Typography className='btn-txt'>
                      Ver testimonio
                    </Typography>
                </Button>
              </Link>
            </div>
          </Grid>
      </>
  );
}

export const TransformacionSection = () => {

  const [open2, setOpen2] = useState(false);

  const handleOpen2 = () => {
    setOpen2(true);
  };

  const handleClose2 = () => {
    setOpen2(false);
  };

  const [openItem, setOpenItem] = useState(0);
  const [manifiestoTab, setManifiestoTab] = useState(0);
  const [manifiestoDirectivosTab, setManifiestoDirectivosTab] = useState(0);

  const handleManifiestoTabChange = (_e: React.SyntheticEvent, newValue: number) => {
    setManifiestoTab(newValue);
  };

  const handleManifiestoDirectivosTabChange = (_e: React.SyntheticEvent, newValue: number) => {
    setManifiestoDirectivosTab(newValue);
  };

  const documentosTecnicos2025 = [
    { title: 'PIAR - Plan Individual de Apoyos y Ajustes Razonables', description: 'Propuesta de orientaciones para la elaboración del Plan Individual de Apoyos y Ajustes Razonables (PIAR)', pdf: docPIAR },
    { title: 'Orientaciones TDAH', description: 'Orientaciones técnicas, administrativas, pedagógicas y didácticas para la atención educativa de niñas, niños, adolescentes y jóvenes con trastornos específicos del aprendizaje y/o con trastornos por déficit de atención con/sin hiperactividad', pdf: docTDAH },
    { title: 'Orientaciones Talentos Excepcionales', description: 'Orientaciones técnicas, administrativas, pedagógicas y didácticas para la atención educativa a estudiantes con capacidades o talentos excepcionales', pdf: docTalentos },
    { title: 'Informe Acciones Estratégicas', description: 'Informe acciones estratégicas para apoyar la educación inclusiva', pdf: docInforme },
    { title: 'Orientaciones Discapacidad', description: 'Orientaciones técnicas, administrativas, pedagógicas y didácticas para la garantía del derecho a la educación de personas con discapacidad', pdf: docDiscapacidad },
    { title: 'Orientaciones Talentos Excepcionales (DOC01)', description: 'Orientaciones técnicas, administrativas, pedagógicas y didácticas para la atención educativa a personas con capacidades y talentos excepcionales', pdf: docMEN_DOC01 },
    { title: 'Revista Apartado', description: 'Revista digital región Apartado', pdf: revistaApartado },
  ];

  const manifiestosRegionales2025 = [
    { nombre: 'Antioquia - Apartadó', pdf: manifiestoAntioquia, img: manifiestoAntioquiaImg },
    { nombre: 'Mitú', pdf: manifiestoMitu, img: manifiestoMituImg },
    { nombre: 'Chocó - Quibdó', pdf: manifiestoChoco, img: manifiestoChocoImg },
    { nombre: 'Guainía - Puerto Inírida', pdf: manifiestoGuainia, img: manifiestoGuainiaImg },
    { nombre: 'Huila - Pitalito', pdf: manifiestoHuila, img: manifiestoHuilaImg },
    { nombre: 'Norte de Santander - Cúcuta', pdf: manifiestoNteSantander, img: manifiestoNteSantanderImg },
    { nombre: 'La Guajira', pdf: manifiestoGuajira, img: manifiestoGuajiraImg },
    { nombre: 'Córdoba - Montería', pdf: manifiestoCordoba, img: manifiestoCordobaImg },
    { nombre: 'Meta - Villavicencio', pdf: manifiestoMeta, img: manifiestoMetaImg },
    { nombre: 'Cauca', pdf: manifiestoCauca, img: manifiestoCaucaImg },
    { nombre: 'Casanare', pdf: manifiestoCasanare, img: manifiestoCasanareImg },
    { nombre: 'Caquetá - Florencia', pdf: manifiestoCaqueta, img: manifiestoCaquetaImg },
    { nombre: 'Putumayo', pdf: manifiestoPutumayo, img: manifiestoPutumayoImg },
    { nombre: 'Guaviare', pdf: manifiestoGuaviare, img: manifiestoGuaviareImg },
    { nombre: 'Tolima', pdf: manifiestoTolima, img: manifiestoTolimaImg },
    { nombre: 'Vichada', pdf: manifiestoVichada, img: manifiestoVichadaImg },
    { nombre: 'Valle del Cauca', pdf: manifiestoValle, img: manifiestoValleImg },
    { nombre: 'Santander', pdf: manifiestoSantander, img: manifiestoSantanderImg },
    { nombre: 'Sucre', pdf: manifiestoSucre, img: manifiestoSucreImg },
  ];

  const toggleItem = (itemIndex: any) => {
    setOpenItem(itemIndex);
  };

  useEffect(() => {
    const items = document.querySelectorAll('[id^="item-"]');
    
    items.forEach((item) => {
      item.classList.remove('active-item');
    });

    const activeItem = document.getElementById(`item-${openItem}`);
    if (activeItem) {
      activeItem.classList.add('active-item');
    }
  }, [openItem]);

  const directivos_info = [
    { title: "Amazonas",
      description: "La escuela ha enfrentado el desafío de educar a estos estudiantes sin contar...",
      fullDescription: "La escuela ha enfrentado el desafío de educar a estos estudiantes sin contar con intérpretes o modelos lingüísticos adecuados. Los docentes, sin experiencia previa en lengua de señas, han desarrollado estrategias para avanzar en su aprendizaje, utilizando herramientas visuales como videos, imágenes y escritura. La profesora Yaneth Patricia Camargo, de lengua castellana, menciona la dificultad inicial de comunicación, pero destaca el vínculo cercano que han construido con el tiempo. Ronald Hilo, docente de matemáticas, ha implementado actividades vinculadas al deporte, aprovechando el interés de Fabio y Edward, como ejercicios matemáticos prácticos y visuales. Los docentes se han capacitado en Lengua de señas y se ha asesorado con el INSOR.",
      video: "https://drive.google.com/file/d/1LRvJpZyiDvdh3X5GDZ9PL2DoYuXfKNt8/preview"
    },
    { title: "San Andrés",
      description: 'El docente encargado, Alfonso Peterson, ha utilizado estas experiencias...',
      fullDescription: 'El docente encargado, Alfonso Peterson, ha utilizado estas experiencias como un incentivo para especializarse en educación inclusiva. Actualmente, cursa un diplomado en la Unidad de Atención a la Inclusión (UAI) y ha desarrollado prácticas pedagógicas innovadoras para responder a la diversidad en el aula. Además, fomenta el respeto por la diversidad y promueve la inclusión activa de Jeisen en eventos escolares y culturales, como izadas de bandera y celebraciones de la afrocolombianidad.',
      video: "https://drive.google.com/file/d/1qBfdK1Qc6f2i2qfBRyWhPxT8II-x9bWV/preview"
    },
    { title: "Eje cafetero",
      description: "La Institución Educativa Santa Sofía ha sido un pilar en la transformación...",
      fullDescription: 'La Institución Educativa Santa Sofía ha sido un pilar en la transformación educativa y social de Brayan. Desde su ingreso hace cuatro años. Brayan pasó rápidamente de no saber leer ni escribir a avanzar en sus estudios y ser promovido de manera inmediata a grados superiores. El profesor Fredy destaca la importancia de reconocer que cada persona aprende de manera diferente, enfatizando la necesidad de implementar una flexibilización curricular y utilizar andamiajes que faciliten el aprendizaje. Su consejo para los educadores es: "Imagínese cómo sería estar en el lugar de ese estudiante".',
      video: "https://drive.google.com/file/d/1XU2O1VnmpoMfQNAryXp_NPcVSUOShTvk/preview"
    },
    { title: "Antioquia",
      description: "La docente a cargo, Gloria Roldán, junto con la docente de apoyo...",
      fullDescription: "La docente a cargo, Gloria Roldán, junto con la docente de apoyo Claudia Graciano, y la orientadora Margarita  han implementado estrategias basadas en el Diseño Universal para el Aprendizaje (DUA) para promover un entorno inclusivo. Resaltan la importancia del apoyo familiar.",
      video: "https://drive.google.com/file/d/1btHCKmczYZqJJ59OFiiB3QWYRKW6AjsT/preview"
    },
    { title: "Santander",
      description: "La institución ha realizado un esfuerzo significativo por superar...",
      fullDescription: "La institución ha realizado un esfuerzo significativo por superar barreras metodológicas y logísticas, implementando estrategias pedagógicas flexibles y utilizando recursos audiovisuales para facilitar el aprendizaje. El profesor Óscar Javier reflexiona sobre los estigmas que tenía inicialmente para educar a Cristian y destaca los cambios positivos que ha observado, especialmente en su autonomía y la comunicación con sus pares y docentes.",
      video: "https://drive.google.com/file/d/1aXTi0Q4l3KfUTbyhUGN-aVqRiNK3NByG/preview"
    },
    { title: "Caribe",
      description: "La docente Leidy resalta la importancia de garantizar el derecho...",
      fullDescription: "La docente Leidy resalta la importancia de garantizar el derecho a la educación para todas las personas hospitalizadas. Las aulas hospitalarias (AH) brindan un espacio en el que los niños y niñas pueden olvidar temporalmente su enfermedad y hospitalización. A través de estas estrategias, se ofrece el programa a las familias, comenzando con la matrícula del estudiante en una institución educativa. Luego, se le proporciona atención en el hospital, y cuando el niño o niña egresa, se realiza un tránsito armónico para su reintegro a la institución.",
      video: "https://drive.google.com/file/d/1eyDw06rt-TYzKnaqr_EcgnaHvgPTSlh2/preview"
    },
    { title: "Valle del cauca",
      description: "La IEO, comprometida con su desarrollo, trabajó para adaptar su proceso...",
      fullDescription: "La IEO, comprometida con su desarrollo, trabajó para adaptar su proceso de aprendizaje mediante la creación de un Plan Individual de Ajustes Razonables (PIAR). Este plan flexibilizó el currículo y permitió que Juan Felipe continuará su formación con diferentes  estrategias con el apoyo de docentes dedicados y la colaboración de la Secretaría de Educación, se implementaron medidas como la promoción anticipada para evitar la deserción escolar y asegurar que pudiera culminar sus estudios.",
      video: "https://drive.google.com/file/d/1Ofj_2t9G0s_Q3VkHNFsB5wq1bpDivztF/preview"
    },
    { title: "Arauca",
      description: "Debido a su excelente rendimiento y disciplina, el Instituto Departamental...",
      fullDescription: "Debido a su excelente rendimiento y disciplina, el Instituto Departamental del Deporte y la Recreación (INDER) de Arauca solicitó a su cuidadora su inmediata vinculación al sistema educativo, con el objetivo de permitirle culminar una etapa importante de su vida.",
      video: "https://drive.google.com/file/d/1ZU2jhMGwVKdkvnlZSvMST7nLBPap0yZJ/preview"
    },
    { title: "Tumaco",
      description: "Carlos Palacios, docente de educación física, comparte cómo Evelin...",
      fullDescription: "Carlos Palacios, docente de educación física, comparte cómo Evelin inició su participación en el programa de escuelas deportivas, destacando el papel fundamental de la disciplina en su progreso. Por su parte, el profesor Frank Castillo, director del grupo de danza, subraya el impacto transformador del arte en las vidas de las personas. De manera similar, Jhon Jairo, director de la Casa Lúdica, resalta la importancia tanto del arte como del deporte como herramientas clave para transformar vidas y generar cambios positivos.",
      video: "https://drive.google.com/file/d/1FRFdNchQXdEcZbIMcbHweHGx6n5wOEGE/preview"
    },
    { title: "Cesar",
      description: "La docente de apoyo Nelvis Cantillo destaca la importancia de implementar...",
      fullDescription: "La docente de apoyo Nelvis Cantillo destaca la importancia de implementar ajustes razonables para estudiantes con discapacidad, talentos y capacidades excepcionales, así como para aquellos en condición de enfermedad. Además, subraya la relevancia de capacitar a los docentes para responder a las necesidades individuales de estos estudiantes. Por su parte, la profesora Luz Marina Galván resalta el valor del PIAR (Plan Individual de Ajustes Razonables) como herramienta para motivar a los estudiantes en su proceso de aprendizaje. También enfatiza la importancia de comprender la forma de comunicación de Alejandra, especialmente a través de su expresión gráfica.",
      video: "https://drive.google.com/file/d/1vlYghEyPC8yCP3iCettDZSeIrWpAhPSU/preview"
    },
    { title: "Andina- Funza",
      description: "La Institución Educativa Técnica Bicentenario ha implementado cambios...",
      fullDescription: "La Institución Educativa Técnica Bicentenario ha implementado cambios significativos en sus prácticas pedagógicas para apoyar la inclusión de estudiantes como Juan Gabriel. Desde el uso de herramientas tecnológicas adaptadas, como el software JAWS, hasta la implementación del Diseño Universal para el Aprendizaje (DUA), la escuela ha creado un entorno accesible y flexible. Los docentes, como Luis Fernando Soacha y Ana Mercedes Téllez, han jugado un papel clave en adaptar el currículo y fomentar la participación de Juan Gabriel en proyectos interdisciplinarios como el semillero de investigación COBIIN.",
      video: "https://drive.google.com/file/d/1MuOvc5eQEeCzAvaHWLXIwgZkyYMcvgWh/preview"
    },
    { title: "Andina- Duitama",
      description: "Erika Gordillo, directora de curso, menciona que desde 2019 el colegio...",
      fullDescription: "Erika Gordillo, directora de curso, menciona que desde 2019 el colegio fue focalizado para abrir la oferta educativa para estudiantes sordos. Por su parte, Yuli, la modelo lingüístico, destaca la importancia de la adquisición de la Lengua de Señas Colombiana (LSC) mediante diversas actividades pedagógicas. El video también resalta la creación de una estrategia innovadora para enseñar ciencias naturales utilizando la LSC a todos los estudiantes.",
      video: "https://drive.google.com/file/d/1WuA82ct-5HjOXlbzK7B6lesrJC11vv7N/preview"
    },
    { title: "Nariño - Pasto",
      description: "Milena Bacca, profesora de español y filosofía, destaca la importancia...",
      fullDescription: 'Milena Bacca, profesora de español y filosofía, destaca la importancia del proceso de alfabetización llevado a cabo con Sebastián. Por otro lado, una docente de apoyo describe la educación inclusiva así:  "La educación inclusiva es el respeto por la diferencia, potenciando capacidades. La educación inclusiva somos todos; que todos reciban del sistema lo que verdaderamente necesitan". También se resalta el papel fundamental de la Secretaría de Educación, que ha proporcionado docentes de apoyo para la institución y ha promovido capacitaciones a través de seminarios y congresos en los que participa el 100% del cuerpo docente de la institución educativa, junto con las familias. La profesora Milena concluye con una frase que refleja la esencia de Sebastián: "Eres un gran lector de la vida".',
      video: "https://drive.google.com/file/d/1sNAfAOE1Kovy7habNKjDbt1_V-e9Hj1z/preview"
    },

  ];

  // Videos experiencias 2025
  const videoexperiencias2025 = [
    { 
      title: "Antioquia - Apartadó",
      description: "Experiencia educativa inclusiva en Apartadó, Antioquia. Transformando vidas a través de prácticas pedagógicas innovadoras y participación activa de la comunidad educativa.",
      video: video2025_01
    },
    { 
      title: "Vaupés - Mitú",
      description: "Innovación educativa en Mitú, Vaupés. Implementando estrategias inclusivas que respetan la diversidad cultural y promueven el aprendizaje significativo.",
      video: video2025_02
    },
    { 
      title: "Chocó - Quibdó",
      description: "Transformación educativa en Quibdó, Chocó. Superando barreras y construyendo espacios de equidad para todos los estudiantes.",
      video: video2025_03
    },
    { 
      title: "Guainía - Puerto Inírida",
      description: "Experiencia inclusiva en Puerto Inírida, Guainía. Adaptando prácticas pedagógicas a las necesidades de la comunidad educativa local.",
      video: video2025_04
    },
    { 
      title: "Huila - Pitalito",
      description: "Transformación desde el aula en Pitalito, Huila. Estrategias innovadoras para garantizar educación de calidad para todos.",
      video: video2025_05
    },
    { 
      title: "Caquetá - Florencia",
      description: "Innovación educativa en Florencia, Caquetá. Promoviendo la inclusión y el desarrollo integral de los estudiantes.",
      video: video2025_06
    },
    { 
      title: "Córdoba - Montería",
      description: "Experiencia educativa en Montería, Córdoba. Construyendo aulas inclusivas donde cada estudiante alcanza su máximo potencial.",
      video: video2025_07
    },
    { 
      title: "Norte de Santander - Cúcuta",
      description: "Transformación educativa en Cúcuta, Norte de Santander. Implementando prácticas inclusivas que transforman vidas.",
      video: video2025_08
    },
    { 
      title: "La Guajira",
      description: "Experiencia inclusiva en La Guajira. Respetando la diversidad cultural y promoviendo la equidad educativa.",
      video: video2025_09
    },
    { 
      title: "Meta - Villavicencio",
      description: "Innovación educativa en Villavicencio, Meta. Estrategias pedagógicas que celebran la diversidad en el aula.",
      video: video2025_10
    },
    { 
      title: "Cauca",
      description: "Transformación educativa en Cauca. Construyendo espacios de aprendizaje accesibles para todos los estudiantes.",
      video: video2025_11
    },
    { 
      title: "Casanare",
      description: "Experiencia inclusiva en Casanare. Promoviendo la participación activa de toda la comunidad educativa.",
      video: video2025_12
    },
    { 
      title: "Putumayo",
      description: "Innovación educativa en Putumayo. Implementando el Diseño Universal para el Aprendizaje en las aulas.",
      video: video2025_13
    },
    { 
      title: "Guaviare",
      description: "Transformación educativa en Guaviare. Superando barreras y garantizando educación de calidad para todos.",
      video: video2025_14
    },
    { 
      title: "Vichada",
      description: "Experiencia inclusiva en Vichada. Adaptando estrategias pedagógicas a la realidad local.",
      video: video2025_15
    },
    { 
      title: "Tolima",
      description: "Innovación educativa en Tolima. Promoviendo la equidad y la participación de todos los estudiantes.",
      video: video2025_16
    },
    { 
      title: "Santander",
      description: "Transformación educativa en Santander. Estrategias inclusivas que transforman aulas y comunidades.",
      video: video2025_17
    },
    { 
      title: "Valle del Cauca",
      description: "Experiencia inclusiva en Valle del Cauca. Construyendo aulas donde todos aprenden y participan.",
      video: video2025_18
    },
    { 
      title: "Sucre",
      description: "Innovación educativa en Sucre. Celebrando la diversidad y promoviendo el aprendizaje significativo para todos.",
      video: video2025_19
    },
  ];

  return (
    <>

      {/* Banner section */}
      <Grid container className='Transformacion-banner-container'>
        <Grid item xs={12} lg={6} className='logos-left'>
          <img className="logo-1" alt="Logo Ministerio de educación" src={logo_educacion} />
        </Grid>
        <Grid item xs={12} lg={6} className='content-right'>
          <h1 className='title'><b>Transformación desde el aula</b></h1>
        </Grid>
      </Grid>

      {/* Description section */}
      <Grid container className='Transformacion-description-container backContraste'>
        <Grid item xs={12} className='text-container'>
          <Grid xs={11}>
            <Typography className='title'>
              Impulsamos la transformación desde el aula, un espacio donde la diversidad se celebra como una riqueza y cada estudiante encuentra oportunidades para aprender, convivir, crecer, alcanzar su máximo potencial y contribuir al bien común.
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={12} className='text-container'>
          <Grid item xs={11} lg={10}>
            <Typography className='text-info'>
              Esta sección está diseñada para que directivos docentes, docentes de aula, docentes orientadores, docentes de apoyo pedagógico, profesionales de apoyo y personal de apoyo promuevan y fortalezcan en sus prácticas educativas la inclusión, equidad, calidad, diversidad, accesibilidad, innovación y compromiso.
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      {/* Manifiestos regionales 2025 - Carousel (optimizado para memoria) */}
      <Grid container className='Transformacion-manifiestos-regionales-container backContraste'>
        <Grid container justifyContent={'center'}>
          <Grid xs={11}>
            <hr className='separator'/>
          </Grid>
        </Grid>
        <Grid item xs={12} className='text-container manifiestos-section-header'>
          <Grid container justifyContent={'center'}>
            <Grid xs={11} lg={8} container justifyContent={'center'}>
              <Typography className='title'>
                Manifiestos regionales 2025
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} className='text-container manifiestos-section-intro'>
          <Grid container justifyContent={'center'}>
            <Grid item xs={11} lg={8} container justifyContent={'center'}>
              <Typography className='text-info'>
                Manifiestos por región de los encuentros celebrados en 2025. Haz clic en cada tarjeta para abrir el PDF.
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid container item xs={12} justifyContent={'center'} className='manifiestos-carousel-wrapper'>
          <Grid item xs={11} lg={10}>
            <Swiper
              modules={[Navigation, Pagination]}
              spaceBetween={16}
              slidesPerView={1.2}
              navigation
              pagination={{ clickable: true }}
              breakpoints={{
                600: { slidesPerView: 2.2 },
                960: { slidesPerView: 3.2 },
                1280: { slidesPerView: 4.2 },
              }}
              className='manifiestos-regionales-carousel'
              aria-label="Carrusel de manifiestos regionales 2025"
            >
              {manifiestosRegionales2025.map((item, index) => (
                <SwiperSlide key={index} className='manifiesto-slide'>
                  <a href={item.pdf} target="_blank" rel="noopener noreferrer" className="revista-link" aria-label={`Abrir PDF: Manifiesto regional ${item.nombre}`}>
                    <div className='image-container'>
                      <img src={item.img} alt={`Portada del manifiesto regional ${item.nombre}`} className='gallery-image' loading="lazy" />
                      <div className='overlay'>
                        <img src={ico_download} alt="" className='icon' aria-hidden="true" />
                        <span className='overlay-text'>Manifiesto {item.nombre}</span>
                      </div>
                    </div>
                  </a>
                </SwiperSlide>
              ))}
            </Swiper>
          </Grid>
        </Grid>
      </Grid>

      {/* Acciones por roles educativos 2025 - Documentos técnicos y revista */}
      {/*<Grid container className='Transformacion-documentos-tecnicos-container backContraste'>
        <Grid container justifyContent={'center'}>
          <Grid xs={11}>
            <hr className='separator'/>
          </Grid>
        </Grid>
        <Grid item xs={12} className='text-container docs-section-header'>
          <Grid container justifyContent={'center'}>
            <Grid xs={11} lg={8} container justifyContent={'center'}>
              <Typography className='title'>
                Acciones por roles educativos 2025
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} className='text-container docs-section-intro'>
          <Grid container justifyContent={'center'}>
            <Grid item xs={11} lg={8} container justifyContent={'center'}>
              <Typography className='text-info'>
                Documentos técnicos, orientaciones y recursos para apoyar la educación inclusiva. Haz clic para abrir el PDF en una nueva pestaña.
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid container item xs={12} className='documentos-tecnicos-grid'>
          {documentosTecnicos2025.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index} className='doc-tecnico-item'>
              <a href={item.pdf} target="_blank" rel="noopener noreferrer" className="doc-tecnico-link" aria-label={`Descargar PDF: ${item.title}`}>
                <div className='doc-tecnico-card'>
                  <Typography component="h3" className='doc-tecnico-title'>{item.title}</Typography>
                  <Typography className='doc-tecnico-desc'>{item.description}</Typography>
                  <Button variant="contained" size="small" className='doc-tecnico-btn' aria-hidden>
                    Ver PDF
                  </Button>
                </div>
              </a>
            </Grid>
          ))}
        </Grid>
      </Grid>*/}

      {/* Acciones section */}
      <Grid container className='Transformacion-acciones-container backContraste'>
        <Grid item xs={12} className='text-container'>
          <Grid xs={11}>
            <Typography className='title'>
              Acciones por roles educativos+
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={12} className='sections-container' role="tablist" aria-label="Seleccionar rol educativo">
          <Grid xs={12} lg={5}>
            <Typography component="button" className='title-2 border-right' onClick={() => toggleItem(0)} id="item-0" role="tab" aria-selected={openItem === 0} aria-controls="panel-directivos" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleItem(0); } }}>
              Directivos docentes, docentes orientadores y docentes de aula
            </Typography>
          </Grid>
          <Grid xs={12} lg={5}>
            <Typography component="button" className='title-2' onClick={() => toggleItem(1)} id="item-1" role="tab" aria-selected={openItem === 1} aria-controls="panel-docentes" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleItem(1); } }}>
              Docentes de apoyo pedagógico, profesionales y personal de apoyo
            </Typography>
          </Grid>
        </Grid>

        {/* Directivos */}
        {openItem === 0 &&
          <>
            <Grid container className='Directivos-container backContraste' id="panel-directivos" role="tabpanel" aria-labelledby="item-0">
            <Grid item xs={12} className='text-container'>
              <Grid xs={11}>
                <Typography className='title'>
                  Historias y videos experienciales
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={12} className='text-container'>
              <Grid item xs={11} lg={10}>
                <Typography className='text-info'>
                  Explora los videos experienciales que narran cómo directivos docentes, docentes de aula y docentes orientadores han transformado las aulas en espacios donde todos los estudiantes, sin excepción, aprenden, participan y desarrollan su potencial. Cada video, grabado en una región, destaca los logros, desafíos y estrategias que han cambiado vidas y generado aprendizaje significativos gracias a prácticas educativas inclusivas, equitativas y de calidad.
                </Typography>
              </Grid>
            </Grid>
            <Swiper
              modules={[Navigation]}
              navigation
              spaceBetween={60}
              slidesPerView={1}
              breakpoints={{
                1024: { slidesPerView: 4 },
                600: { slidesPerView: 1 },
              }}
              pagination={{ clickable: true }}
              className='directivos-carousel'
              aria-label="Carrusel de videos experienciales"
            >
              {directivos_info.map((item, index) => (
                <SwiperSlide key={index} className='directivos-carousel-slide'>
                  <CardDirectivos 
                    title={item.title}
                    imgDesc="video experencial"
                    text={item.description}
                    fullText={item.fullDescription}
                    video={item.video}
                  />
                </SwiperSlide>
              ))}
            </Swiper>

            {/* Videoexperiencias 2025 */}
            <Grid container justifyContent={'center'} className='Transformacion-videoexperiencias2025-container'>
              <Grid xs={11}>
                <hr className='separator'/>
              </Grid>
            </Grid>
            <Grid item xs={12} className='text-container'>
              <Grid xs={11}>
                <Typography className='title'>
                  Videoexperiencias 2025
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={12} className='text-container'>
              <Grid item xs={11} lg={10}>
                <Typography className='text-info'>
                  Descubre las experiencias educativas más recientes de 2025 en diferentes regiones de Colombia. Cada video documenta las transformaciones, innovaciones y logros alcanzados por comunidades educativas comprometidas con la inclusión, equidad y calidad educativa.
                </Typography>
              </Grid>
            </Grid>
            <Grid container item xs={12} justifyContent="center" className='carousel-container'>
              <Grid item xs={11} lg={11}>
                <Swiper
                  modules={[Navigation, Pagination]}
                  navigation
                  spaceBetween={30}
                  slidesPerView={1}
                  breakpoints={{
                    1024: { slidesPerView: 4, spaceBetween: 30 },
                    768: { slidesPerView: 2, spaceBetween: 20 },
                    600: { slidesPerView: 1, spaceBetween: 10 },
                  }}
                  pagination={{ clickable: true, dynamicBullets: true }}
                  className='videoexperiencias-2025-carousel'
                  aria-label="Carrusel de videoexperiencias 2025"
                >
                  {videoexperiencias2025.map((item, index) => (
                    <SwiperSlide key={index} className='videoexperiencias-2025-slide'>
                      <CardVideo2025 
                        title={item.title}
                        text={item.description}
                        video={item.video}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </Grid>
            </Grid>

            <Grid container justifyContent={'center'} className='Transformacion-manifiesto-container backContraste'>
                <Grid xs={11}>
                  <hr className='separator'/>
                </Grid>
              </Grid>
              <Grid item xs={12} className='text-container'>
                <Grid xs={11}>
                  <Typography className='title'>
                    Manifiesto nacional por una Educación Inclusiva, Equitativa y de Calidad de los Directivos Docentes, Docentes Orientadores y Docentes de Aula que asistieron a los encuentros celebrados en 12 regiones del país en el mes de noviembre de 2024 y 2025
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={12} className='text-container'>
                <Grid item xs={11} lg={10}>
                  <Typography className='text-info'>
                    Los docentes, desde sus diversos roles, se unieron para crear este manifiesto que refleja su compromiso con una educación inclusiva, equitativa y de calidad. Un llamado colectivo a transformar aulas, instituciones y comunidades con acciones concretas y colaborativas.
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={12} className='manifiesto-docentes-tabs-container'>
                <Tabs
                  value={manifiestoDirectivosTab}
                  onChange={handleManifiestoDirectivosTabChange}
                  variant="fullWidth"
                  centered
                  className="manifiesto-docentes-tabs"
                  TabIndicatorProps={{ style: { backgroundColor: '#d9488c', height: 4 } }}
                >
                  <Tab label="Nacional 2025" id="manifiesto-directivos-tab-nacional" aria-controls="manifiesto-directivos-panel-nacional" />
                  <Tab label="2024" id="manifiesto-directivos-tab-2024" aria-controls="manifiesto-directivos-panel-2024" />
                </Tabs>
                <Box role="tabpanel" hidden={manifiestoDirectivosTab !== 0} id="manifiesto-directivos-panel-nacional" aria-labelledby="manifiesto-directivos-tab-nacional" className="manifiesto-tab-panel">
                  <Grid container item xs={12} justifyContent={'center'}>
                    <Grid xs={11} lg={10} className='img-container'>
                      <iframe src={manifiestoNacional} className='info-img' title="Manifiesto Nacional 2025"></iframe>
                    </Grid>
                  </Grid>
                </Box>
                <Box role="tabpanel" hidden={manifiestoDirectivosTab !== 1} id="manifiesto-directivos-panel-2024" aria-labelledby="manifiesto-directivos-tab-2024" className="manifiesto-tab-panel">
                  <Grid container item xs={12} justifyContent={'center'}>
                    <Grid xs={11} lg={10} className='img-container'>
                      <iframe src={manifiestodi} className='info-img' title="Manifiesto 2024"></iframe>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
              <Dialog open={open2} onClose={handleClose2} maxWidth='lg'>
                <DialogContent style={{ padding: 0 }}>
                  <img
                    src={manifiestodo}
                    alt='Imagen ampliada'
                    style={{
                      width: '100%',
                      height: 'auto',
                      display: 'block',
                    }}
                  />
                </DialogContent>
              </Dialog>
          </Grid>
          </>
        }

        {/* Docentes */}
        {openItem === 1 &&
          <>
          <Grid container className='Docentes-container backContraste' id="panel-docentes" role="tabpanel" aria-labelledby="item-1">
            <Grid item xs={12} className='text-container'>
              <Grid xs={11}>
                <Typography className='title'>
                  Videos testimoniales
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={12} className='text-container'>
              <Grid item xs={11} lg={10}>
                <Typography className='text-info'>
                  Conoce historias reales de docentes que comparten su experiencia transformadora con la educación inclusiva. Estos testimonios breves reflejan el impacto positivo de construir una comunidad educativa equitativa y diversa.
                </Typography>
              </Grid>
            </Grid>
            <Grid container className='cards-docentes-container'>
              <Grid item xs={12} lg={3} className='card-docentes-space'>
                <CardDocentes 
                  title="Transformando la educación a través de la participación activa en Arauca: Entrevista con Lourdes Medina"
                  img={testimony1}
                  imgDesc="Imagen testimonio"
                  autor="Por: Alejandro García Gómez"
                  testimonio={1}
                />
              </Grid>
              <Grid item xs={12} lg={3} className='card-docentes-space'>
                <CardDocentes 
                  title="Desafíos y Estrategias para Superar Barreras en Grupos Vulnerables de Aguachica, Cesar"
                  img={directivos}
                  imgDesc="Imagen testimonio"
                  autor="Por: Mónica Buelvas"
                  testimonio={2}
                />
              </Grid>
              <Grid item xs={12} lg={3} className='card-docentes-space'>
                <CardDocentes 
                  title="Educación Inclusiva: Una Mirada al Pasado, Presente y Futuro desde el Eje Cafetero"
                  img={testimony3}
                  imgDesc="Imagen testimonio"
                  autor="Por: Olga Lucía López"
                  testimonio={3}
                />
              </Grid>
              <Grid item xs={12} lg={3} className='card-docentes-space'>
                <CardDocentes 
                  title="La Esencia de la Docencia Transformadora en Nariño"
                  img={testimony4}
                  imgDesc="Imagen testimonio"
                  autor="Por: Karen Cruz y Lucía Güiza"
                  testimonio={4}
                />
              </Grid>
              <Grid item xs={12} lg={3} className='card-docentes-space'>
                <CardDocentes 
                  title="La Educación Inclusiva: Un Compromiso con la Diversidad y la Equidad en la Región Antioqueña"
                  img={testimony5}
                  imgDesc="Imagen testimonio"
                  autor="Por: Angelina Beltrán"
                  testimonio={5}
                />
              </Grid>
              <Grid item xs={12} lg={3} className='card-docentes-space'>
                <CardDocentes 
                  title="La Educación Equitativa y de Calidad: Pilar para el Desarrollo Integral en Funza, Cundinamarca"
                  img={testimony3}
                  imgDesc="Imagen testimonio"
                  autor="Por: Marcela Morera"
                  testimonio={6}
                />
              </Grid>
              <Grid item xs={12} lg={3} className='card-docentes-space'>
                <CardDocentes 
                  title="Hacia una Educación Más Inclusiva: Construyendo un Sistema Educativo para Todas y Todos en el Valle del Cauca"
                  img={testimony6}
                  imgDesc="Imagen testimonio"
                  autor="Por: Ana María Ángel Piedrahita"
                  testimonio={7}
                />
              </Grid>
            </Grid>

              {/* Videoexperiencias 2025 */}
              <Grid container justifyContent={'center'} className='Transformacion-videoexperiencias2025-container'>
                <Grid xs={11}>
                  <hr className='separator'/>
                </Grid>
              </Grid>
              <Grid item xs={12} className='text-container'>
                <Grid xs={11}>
                  <Typography className='title'>
                    Videoexperiencias 2025
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={12} className='text-container'>
                <Grid item xs={11} lg={10}>
                  <Typography className='text-info'>
                    Descubre las experiencias educativas más recientes de 2025 en diferentes regiones de Colombia. Cada video documenta las transformaciones, innovaciones y logros alcanzados por comunidades educativas comprometidas con la inclusión, equidad y calidad educativa.
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item xs={12} justifyContent="center" className='carousel-container'>
                <Grid item xs={11} lg={11}>
                  <Swiper
                    modules={[Navigation, Pagination]}
                    navigation
                    spaceBetween={30}
                    slidesPerView={1}
                    breakpoints={{
                      1024: { slidesPerView: 4, spaceBetween: 30 },
                      768: { slidesPerView: 2, spaceBetween: 20 },
                      600: { slidesPerView: 1, spaceBetween: 10 },
                    }}
                    pagination={{ clickable: true, dynamicBullets: true }}
                    className='videoexperiencias-2025-carousel'
                    aria-label="Carrusel de videoexperiencias 2025"
                  >
                    {videoexperiencias2025.map((item, index) => (
                      <SwiperSlide key={index} className='videoexperiencias-2025-slide'>
                        <CardVideo2025 
                          title={item.title}
                          text={item.description}
                          video={item.video}
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </Grid>
              </Grid>

              <Grid container justifyContent={'center'} className='Transformacion-manifiesto-container backContraste'>
                <Grid xs={11}>
                  <hr className='separator'/>
                </Grid>
              </Grid>
              <Grid item xs={12} className='text-container'>
                <Grid xs={11}>
                  <Typography className='title'>
                    Manifiesto nacional por una Educación Inclusiva, Equitativa y de Calidad de los Directivos Docentes, Docentes Orientadores y Docentes de Aula que asistieron a los encuentros celebrados en 12 regiones del país en el mes de noviembre de 2024 y 2025
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={12} className='text-container'>
                <Grid item xs={11} lg={10}>
                  <Typography className='text-info'>
                    Los docentes, desde sus diversos roles, se unieron para crear este manifiesto que refleja su compromiso con una educación inclusiva, equitativa y de calidad. Un llamado colectivo a transformar aulas, instituciones y comunidades con acciones concretas y colaborativas.
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={12} className='manifiesto-docentes-tabs-container'>
                <Tabs
                  value={manifiestoTab}
                  onChange={handleManifiestoTabChange}
                  variant="fullWidth"
                  centered
                  className="manifiesto-docentes-tabs"
                  TabIndicatorProps={{ style: { backgroundColor: '#d9488c', height: 4 } }}
                >
                  <Tab label="Nacional 2025" id="manifiesto-tab-nacional" aria-controls="manifiesto-panel-nacional" />
                  <Tab label="2025" id="manifiesto-tab-2025" aria-controls="manifiesto-panel-2025" />
                  <Tab label="2024" id="manifiesto-tab-2024" aria-controls="manifiesto-panel-2024" />
                </Tabs>
                <Box role="tabpanel" hidden={manifiestoTab !== 0} id="manifiesto-panel-nacional" aria-labelledby="manifiesto-tab-nacional" className="manifiesto-tab-panel">
                  <Grid container item xs={12} justifyContent={'center'}>
                    <Grid xs={11} lg={10} className='img-container'>
                      <iframe src={manifiestoNacional} className='info-img' title="Manifiesto Nacional 2025"></iframe>
                    </Grid>
                  </Grid>
                </Box>
                <Box role="tabpanel" hidden={manifiestoTab !== 1} id="manifiesto-panel-2025" aria-labelledby="manifiesto-tab-2025" className="manifiesto-tab-panel">
                  <Grid container item xs={12} justifyContent={'center'}>
                    <Grid xs={11} lg={10} className='img-container'>
                      <iframe src={manifiestoDocentes2025} className='info-img' title="Manifiesto 2025"></iframe>
                    </Grid>
                  </Grid>
                </Box>
                <Box role="tabpanel" hidden={manifiestoTab !== 2} id="manifiesto-panel-2024" aria-labelledby="manifiesto-tab-2024" className="manifiesto-tab-panel">
                  <Grid container item xs={12} justifyContent={'center'}>
                    <Grid xs={11} lg={10} className='img-container'>
                      <iframe src={manifiestoDocentes2024} className='info-img' title="Manifiesto 2024"></iframe>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
              <Dialog open={open2} onClose={handleClose2} maxWidth='lg'>
                <DialogContent style={{ padding: 0 }}>
                  <img
                    src={manifiestodo}
                    alt='Imagen ampliada'
                    style={{
                      width: '100%',
                      height: 'auto',
                      display: 'block',
                    }}
                  />
                </DialogContent>
              </Dialog>
          </Grid>
          </>
        }

      </Grid>

      

      {/* Classroom section */}
      {/*<Grid container className='Transformacion-classroom-container'>
        <Grid container justifyContent={'center'}>
          <Grid xs={11}>
            <hr className='separator'/>
          </Grid>
        </Grid>
        <Grid item xs={12} className='text-container'>
          <Grid xs={11} lg={8}>
            <Typography className='title'>
              Espacio virtual de interacción
            </Typography>
          </Grid>
        </Grid>
        <Grid container item xs={12} justifyContent={'center'}>
          <Grid xs={11} lg={4} className='img-container'>
            <img src={classroom} alt='Icono de classroom' className='info-img' />
          </Grid>
          <Grid item xs={12} lg={5} className='text-container'>
           <Grid xs={11}>
            <Typography className='text-info'>
              Un espacio diseñado para que directivos y docentes puedan interactuar con profesionales del convenio, aclarar inquietudes y compartir estrategias para promover la inclusión en sus instituciones.
            </Typography>
            <div className='button-container'>
                <Button type="submit" variant="contained" fullWidth className='submit-button'>
                    <Typography className='btn-txt'>
                      Classroom
                    </Typography>
                </Button>
            </div>
           </Grid> 
          </Grid>
        </Grid> 
      </Grid>*/}

    </>
  );
};